/**
 * FCM Query Options — Layer 2 of the three-layer pattern.
 *
 * Reusable TanStack Query option objects for FCM device subscriptions.
 */
import { queryOptions } from "@tanstack/react-query";
import { getFcmSubscriptions } from "./fcmApi";
import { notificationKeys } from "@/shared/lib/queryKeys";

/** GET /api/v1/notifications/devices — active + inactive FCM device records. */
export const getFcmDevicesQueryOptions = queryOptions({
  queryKey: notificationKeys.devices(),
  queryFn: ({ signal }) => getFcmSubscriptions(signal),
  staleTime: 1000 * 30,
  retry: 1,
});
